import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "@atrix-analytics/ui";
import { api, clearRegionTokens } from "../api";
import { errorMessage } from "../api/http";

export function useSignOut() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return async () => {
    try {
      await api.signOut();
    } catch (err) {
      toast.error(errorMessage(err));
      return;
    }
    clearRegionTokens();
    qc.clear();
    qc.setQueryData(["me"], null);
    await navigate({ to: "/sign-in", search: {} });
  };
}
